var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-hidden"},[_c('div',{staticClass:"text-right mb-2"},[(!_vm.firefoxAgent)?_c('v-avatar',{staticClass:"ma-2 white--text",attrs:{"color":"#0f2027","size":"67","outlined":""}},[_c('Speed')],1):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }